"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSBBAccountSettingAutopayComponent = void 0;
const account_service_1 = require("../../services/account.service");
const billing_service_1 = require("../../../billing/services/billing.service");
class CSBBAccountSettingAutopayComponent {
    constructor(accountService, billingService) {
        this.accountService = accountService;
        this.billingService = billingService;
        this.autopayError = false;
        this.accountDetails();
    }
    ngOnInit() {
        this.paymentType();
    }
    // for paperless
    accountDetails(cacheResponse) {
        this.accountService.getAccountDetails(cacheResponse)
            .subscribe((billingHistory) => {
            this.enrollAutopay = billingHistory.ebill;
            if (billingHistory.ebill) {
                this.billingType = 'true';
            }
            else {
                this.billingType = 'false';
            }
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    // for autopay
    paymentType() {
        this.loader = true;
        this.billingService.getAutoPayType()
            .subscribe((data) => {
            this.loader = false;
            this.autopayError = false;
            if (data !== null) {
                this.isAutoPayEnrolled = true;
                if (data.paymentType !== undefined && data.paymentType === 'MAPI') {
                    this.isTextPay = true;
                }
            }
            else {
                this.isAutoPayEnrolled = false;
            }
        }, (err) => {
            this.autopayError = true;
            this.error = err;
            this.loader = false;
        });
    }
    updatePaymentMode() {
        if (this.isAutoPayEnrolled === true) {
            location.href = '/my_account/personal/#/wireless/stopautopay';
        }
        else if (this.isAutoPayEnrolled === false) {
            location.href = '/my_account/personal/#/wireless/autopay';
        }
    }
}
exports.CSBBAccountSettingAutopayComponent = CSBBAccountSettingAutopayComponent;
//# sourceMappingURL=bbautopay.component.js.map